import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var Lumo =
/*#__PURE__*/
function (_HTMLElement) {
  _inherits(Lumo, _HTMLElement);

  function Lumo() {
    _classCallCheck(this, Lumo);

    return _possibleConstructorReturn(this, _getPrototypeOf(Lumo).apply(this, arguments));
  }

  _createClass(Lumo, null, [{
    key: "version",
    get: function get() {
      return '1.5.0';
    }
  }]);

  return Lumo;
}(_wrapNativeSuper(HTMLElement));

customElements.define('vaadin-lumo-styles', Lumo);
export { Lumo };